import cxs from 'cxs';
import { COLOURS, FONT_SIZES } from '../../../common/styles/vars';

const GRADIENT = {
  backgroundImage: `linear-gradient(-180deg, rgba(0, 0, 0, 0) 0%, ${COLOURS.mono.black} 100%)`,
  borderRadius: 'inherit',
  content: '""',
  display: 'block',
  height: 'inherit',
  position: 'relative',
  width: 'inherit'
};

export const IMAGE_CARD = (width, height) => cxs({
  '> .image': {
    '&::after ': {
      ...GRADIENT
    }
  },
  position: 'relative',
  borderRadius: '6px',
  width,
  height,
  margin: '0',
  cursor: 'pointer'
});

export const IMAGE_CARD_EMPTY = cxs({
  '&::after ': {
    ...GRADIENT
  },
  borderRadius: '6px',
  margin: '0',
  width: '100%',
  height: '100%',
  minWidth: '100%',
  backgroundColor: COLOURS.grey.athens.bigFat
});

export const IMAGE_CARD_CHILD = cxs({
  position: 'absolute',
  zIndex: 10,
  left: '20px',
  bottom: '15px',
  '> .title': {
    fontSize: FONT_SIZES.default,
    color: COLOURS.mono.white,
    letterSpacing: '1px',
    lineHeight: '20px',
    margin: '0',
    marginBottom: '2px',
    textTransform: 'uppercase'
  },
  '> .sub-title': {
    fontSize: FONT_SIZES.small,
    color: COLOURS.mono.white,
    letterSpacing: '1px',
    lineHeight: '17px',
    margin: '0'
  }
});